// src/components/AdminLayout.js
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const adminNav = [
  { to: '/admin', label: 'Dashboard', icon: '📊', exact: true },
  { to: '/admin/users', label: 'Users', icon: '👥' },
  { to: '/admin/kyc', label: 'KYC Queue', icon: '✅' },
  { to: '/admin/transactions', label: 'Transactions', icon: '💱' },
  { to: '/admin/listings', label: 'Listings', icon: '📋' },
  { to: '/admin/market', label: 'Market Control', icon: '📡' },
  { to: '/admin/news', label: 'News', icon: '📰' },
  { to: '/admin/leads', label: 'Buyer Leads', icon: '📬' },
  { to: '/admin/registry', label: 'Registry', icon: '🧾' },
  { to: '/admin/exchange', label: 'Exchange', icon: '🪙' },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* SIDEBAR */}
      <aside style={{ width: '240px', background: 'var(--bg2)', borderRight: '1px solid var(--border)', position: 'fixed', top: 0, left: 0, bottom: 0, overflow: 'auto', zIndex: 100, display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '1.5rem', borderBottom: '1px solid var(--border)' }}>
          <Link to="/admin" style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '1.5rem', letterSpacing: '3px', background: 'linear-gradient(135deg,#00ff88,#00e5ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textDecoration: 'none', display: 'block' }}>CarbonX</Link>
          <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', letterSpacing: '2px', color: '#ff6600', marginTop: '0.3rem' }}>ADMIN PANEL</div>
        </div>

        <nav style={{ flex: 1, padding: '1rem 0' }}>
          {adminNav.map(({ to, label, icon, exact }) => {
            const active = exact ? location.pathname === to : location.pathname.startsWith(to);
            return (
              <Link key={to} to={to} style={{
                display: 'flex', alignItems: 'center', gap: '0.8rem',
                padding: '0.75rem 1.5rem',
                color: active ? 'var(--neon-cyan)' : 'var(--muted)',
                textDecoration: 'none',
                fontFamily: 'Space Mono, monospace',
                fontSize: '0.7rem', letterSpacing: '1.5px',
                textTransform: 'uppercase',
                background: active ? 'rgba(0,229,255,0.08)' : 'transparent',
                borderLeft: active ? '2px solid var(--neon-cyan)' : '2px solid transparent',
                transition: 'all 0.2s',
              }}>
                <span>{icon}</span> {label}
              </Link>
            );
          })}
        </nav>

        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid var(--border)' }}>
          <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.65rem', color: 'var(--muted)', marginBottom: '0.5rem' }}>{user?.name}</div>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            <Link to="/" style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', color: 'var(--muted)', textDecoration: 'none', letterSpacing: '1px' }}>← Site</Link>
            <button onClick={() => { logout(); navigate('/'); }} style={{ background: 'transparent', border: 'none', color: '#ff0099', fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', cursor: 'pointer', letterSpacing: '1px', padding: 0 }}>Logout</button>
          </div>
        </div>
      </aside>

      {/* CONTENT */}
      <main style={{ flex: 1, marginLeft: '240px', padding: '2rem', minHeight: '100vh' }}>
        {children}
      </main>
    </div>
  );
}
